const airportParser = (airports, code) => {
  return airports.find((airport) => airport.fs === code);
};

export default airportParser;
